<template>
  <div id="insuranceApply">
    <!-- 로더 -->
    <loader v-if="loaderActive"></loader>
    <div class="container">
      <div class="row">
        <div class="col-md-offset-3 col-md-6 col-xs-12">
          <h2 class="title">비즈해줌 보험대행 신청서</h2>
          <div class="apply-step">
            <div class="row">
              <div :class="['col-xs-6', {'apply-step-active': !isNext}]">
                <div class="text-left">STEP 01</div>
                <div class="text-right">개인정보 입력</div>
              </div>
              <div :class="['col-xs-6', {'apply-step-active': isNext}]">
                <div class="text-left">STEP 02</div>
                <div class="text-right">발전소정보</div>
              </div>
            </div>
          </div>
          <form class="apply-form" @submit.prevent="onSubmit">
            <div v-show="!isNext">
              <div class="row form-group">
                <div class="col-md-4">
                  <label>상호</label>
                </div>
                <div class="col-md-8">
                  <input type="text"
                         class="hz-input-default hz-input-lg input-text"
                         placeholder="사업자명을 입력해주세요."
                         maxlength="50"
                         data-vv-name="owner_name"
                         v-validate="{required: true, max: 50}"
                         v-model="data['owner_name']"/>
                  <p v-if="errors.first('owner_name')" class="is-invalid-text">{{ errors.first('owner_name') }}</p>
                  <p class="explain-text">사업자등록증 상의 상호를 입력해주세요.</p>
                </div>
              </div>
              <div class="row form-group">
                <div class="col-md-4">
                  <label>성명</label>
                </div>
                <div class="col-md-8">
                  <input type="text"
                         class="hz-input-default hz-input-lg input-text"
                         placeholder="성명을 입력해주세요."
                         maxlength="50"
                         data-vv-name="onm_name"
                         v-validate="{required: true, max: 50}"
                         v-model="data['name']"/>
                  <p v-if="errors.first('onm_name')" class="is-invalid-text">{{ errors.first('onm_name') }}</p>
                  <p class="explain-text">계약자(사업주)의 성명을 입력해주세요.</p>
                </div>
              </div>
              <div class="row form-group">
                <div class="col-md-4">
                  <label>핸드폰번호</label>
                </div>
                <div class="col-md-8">
                  <input-phone :class="['hz-input-default', 'hz-input-lg', {'is-invalid': errors.first('mobile_no')}]"
                               placeholder="핸드폰번호를 입력해주세요."
                               data-vv-name="mobile_no"
                               v-validate="{required: true, min:9, max:20}"
                               :maxLength="20"
                               v-model="data['mobile_no']"></input-phone>
                  <p v-if="errors.first('mobile_no')" class="is-invalid-text">{{ errors.first('mobile_no') }}</p>
                   <p class="explain-text">계약자(사업주)의 핸드폰번호를 입력해주세요.</p>
                </div>
              </div>
              <div class="row form-group">
                <div class="col-md-4">
                  <label>이메일</label>
                </div>
                <div class="col-md-8">
                  <input type="text"
                         class="hz-input-default hz-input-lg"
                         maxlength="50"
                         placeholder="이메일을 입력해주세요."
                         data-vv-name="email"
                         v-validate="{required: true, email: true, max: 50}"
                         v-model="data['email']">
                  <p v-if="errors.first('email')" class="is-invalid-text">{{ errors.first('email') }}</p>
                  <p class="explain-text">계약자(사업주)의 이메일을 입력해주세요.</p>
                </div>
              </div>
            </div>
            <div v-show="isNext">
              <div class="form-category">
                <h4>발전소정보</h4>
              </div>
              <div class="row form-group">
                <div class="col-md-4">
                  <label>발전소 주소</label>
                </div>
                <div class="col-md-8">
                  <input-address type="text"
                                 class="col-xs-12 hz-address-default padding-0"
                                 data-vv-name="address"
                                 maxlength="255"
                                 v-validate="{required: true, max: 255}"
                                 v-model="data['address']"
                                 placeholder="발전소 주소를 입력해주세요.">
                  </input-address>
                  <p v-if="errors.first('address')" class="is-invalid-text">{{ errors.first('address') }}</p>
                </div>
              </div>
              <div class="row form-group">
                <div class="col-md-4">
                  <label>발전소명</label>
                </div>
                <div class="col-md-8">
                  <input type="text"
                         class="hz-input-default hz-input-lg input-text"
                         placeholder="발전소명을 입력해주세요."
                         maxlength="100"
                         data-vv-name="plant_name"
                         v-validate="{required: true, max: 100}"
                         v-model="data['plant_name']"/>
                  <p v-if="errors.first('plant_name')" class="is-invalid-text">{{ errors.first('plant_name') }}</p>
                </div>
              </div>
              <div class="row form-group">
                <div class="col-md-4">
                  <label>설치위치</label>
                </div>
                <div class="col-md-8">
                  <drop-down-list data-vv-name="install_position"
                                  v-validate="{required: true}"
                                  :options="installPositionOptions"
                                  :size="'hz-dropdownlist-lg'"
                                  v-model="data['install_position']"></drop-down-list>
                  <p v-if="errors.first('install_position')" class="is-invalid-text">{{ errors.first('install_position') }}</p>
                </div>
              </div>
              <div class="row form-group">
                <div class="col-md-4">
                  <label>설치용량</label>
                </div>
                <div class="col-md-8">
                  <input-float class="hz-input-lg hz-input-default input-spin-none"
                               data-vv-name="install_capacity"
                               v-validate="{required: true, min_value: 1}"
                               v-model="data['install_capacity']"/>
                  <span class="hz-unit">kWp</span>
                  <p v-if="errors.first('install_capacity')" class="is-invalid-text">{{ errors.first('install_capacity') }}</p>
                </div>
              </div>
              <div class="row form-group">
                <div class="col-md-4">
                  <label>설치유형</label>
                </div>
                <div class="col-md-8">
                  <drop-down-list data-vv-name="install_type"
                                  v-validate="{required: true}"
                                  :options="installTypeOptions"
                                  :size="'hz-dropdownlist-lg'"
                                  v-model="data['install_type']"></drop-down-list>
                  <p v-if="errors.first('install_type')" class="is-invalid-text">{{ errors.first('install_type') }}</p>
                </div>
              </div>
              <div class="row form-group">
                <div class="col-md-4">
                  <label>구동방식</label>
                </div>
                <div class="col-md-8">
                  <drop-down-list data-vv-name="driving_method"
                                  v-validate="{required: true}"
                                  :options="drivingMethodOptions"
                                  :size="'hz-dropdownlist-lg'"
                                  v-model="data['driving_method']"></drop-down-list>
                  <p v-if="errors.first('driving_method')" class="is-invalid-text">{{ errors.first('driving_method') }}</p>
                </div>
              </div>
              <div class="row form-group margin-bottom-48">
                <div class="col-md-4">
                  <label>공제보험 개시일자</label>
                </div>
                <div class="col-md-8">
                  <date-picker :size="'hz-picker-lg'"
                               data-vv-name="deduction_date"
                               v-validate="{required: true}"
                               data-toggle="popover"
                               data-trigger="hover"
                               data-placement="bottom"
                               :placeholder="'공제보험 개시일자를 입력해주세요.'"
                               v-model="data['deduction_date']"></date-picker>
                  <p v-if="errors.first('deduction_date')" class="is-invalid-text">{{ errors.first('deduction_date') }}</p>
                </div>
              </div>
              <div class="form-category">
                <h4>가입첨부서류</h4>
              </div>
              <div class="form-group">
                <div class="col-md-4">
                  <label>사업자등록증</label>
                </div>
                <div class="col-md-8">
                  <input-file data-vv-name="license_file"
                              v-validate="{required: true}"
                              :auth="true"
                              :autoUpload="true"
                              :options="fileUploadOptions"
                              :saveUrl="fileSaveUrl + '?category=license_file'"
                              :removeUrl="fileRemoveUrl"
                              v-model="data['license_file']"></input-file>
                  <p v-if="errors.first('license_file')" class="is-invalid-text">{{ errors.first('license_file') }}</p>
                  <p class="explain-text">pdf, jpg, png 파일(5MB이하)로 업로드 해주세요.</p>
                </div>
              </div>
              <div class="form-group">
                <div class="col-md-4">
                  <label>발전사업허가증</label>
                </div>
                <div class="col-md-8">
                  <input-file data-vv-name="permission_file"
                              v-validate="{required: true}"
                              :auth="true"
                              :autoUpload="true"
                              :options="fileUploadOptions"
                              :saveUrl="fileSaveUrl + '?category=permission_file'"
                              :removeUrl="fileRemoveUrl"
                              v-model="data['permission_file']"></input-file>
                  <p v-if="errors.first('permission_file')" class="is-invalid-text">{{ errors.first('permission_file') }}</p>
                  <p class="explain-text">pdf, jpg, png 파일(5MB이하)로 업로드 해주세요.</p>
                </div>
              </div>
            </div>
            <!-- 버튼 -->
            <div class="onm-btn-wrap col-xs-12 text-center">
              <button type="button" v-if="isNext" class="hz-btn-default hz-btn-lg"
                      style="border-color: #39496b; background-color: #ffffff;"
                      @click.prevent="isNext = false">이전</button>
              <button type="submit" class="hz-btn-primary hz-btn-lg">{{ submitBtnName }}</button>
            </div>
          </form>
        </div>
      </div>
    </div>
    <!-- 알림창 -->
    <modal ref="notifyModal" :id="notifyModal.id" :type="notifyModal.type" :title="notifyModal.title"
           :size="notifyModal.size" :fields="notifyModal.fields"></modal>
    <!-- 신청완료 알림 -->
    <modal ref="applyDoneModal" :id="applyDoneModal.id" :type="applyDoneModal.type" :title="applyDoneModal.title"
           :size="applyDoneModal.size" :fields="applyDoneModal.fields"></modal>
  </div>
</template>

<script>
  import api from '@/api/onm'
  import Loader from 'common/components/Loader'
  import InputAddress from 'common/components/InputAddress'
  import InputPhone from 'common/components/InputPhone'
  import InputFloat from 'common/components/InputFloat'
  import InputFile from 'common/components/InputFile'
  import DropDownList from 'common/components/DropDownList'
  import DatePicker from 'common/components/DatePicker'
  import Modal from 'common/components/Modal'
  import { mapActions } from 'vuex'

  export default {
    name: 'insurance-apply',
    components: {
      Loader,
      InputAddress,
      InputPhone,
      InputFloat,
      InputFile,
      DatePicker,
      DropDownList,
      Modal
    },
    computed: {
      submitBtnName: function () {
        const name = this.isNext ? '신청' : '다음'
        return name
      }
    },
    data: function () {
      return {
        loaderActive: false,
        isNext: false,
        data: {
          owner_name: '',
          name: '',
          mobile_no: '',
          email: '',
          address: '',
          plant_name: '',
          install_position: '',
          install_capacity: 0,
          install_type: '',
          driving_method: '',
          deduction_date: '',
          license_file: [],
          permission_file: []
        },
        installPositionOptions: [
          {name: '지붕(슬라브)', value: 'SB'},
          {name: '지붕(판넬)', value: 'PN'},
          {name: '평지', value: 'FL'},
          {name: '농지', value: 'FM'},
          {name: '임야', value: 'FR'},
          {name: '야산', value: 'MT'},
          {name: '수상', value: 'WT'},
          {name: '기타', value: 'ETC'}
        ],
        installTypeOptions: [
          {name: '일반태양광', value: 'GN'},
          {name: '농촌태양광', value: 'FV'},
          {name: '영농형 태양광', value: 'FM'},
          {name: '협동조합', value: 'CP'},
          {name: '기타', value: 'ETC'}
        ],
        drivingMethodOptions: [
          {name: '고정형', value: 'FX'},
          {name: '고정가변형', value: 'FV'},
          {name: '단축추적식', value: 'ST'},
          {name: '양축추적식', value: 'DT'},
          {name: '기타', value: 'ETC'}
        ],
        fileSaveUrl: location.protocol + '//' + location.hostname.replace('biz', 'api') + '/biz/maintenance/file/',
        fileRemoveUrl: location.protocol + '//' + location.hostname.replace('biz', 'api') + '/biz/maintenance/file/delete/',
        fileUploadOptions: {
          validation: {
            allowedExtensions: ['.pdf', '.jpg', '.jpeg', '.png'],
            maxFileSize: 5 * 1024 * 1024,
            minFileSize: 0
          }
        },
        notifyModal: {
          id: 'notifyModal',
          type: 'alert',
          title: '알림',
          size: 'modal-sm',
          fields: [
            {
              type: 'message',
              message: ['입력정보를 확인해주세요.'],
              class: 'text-center'
            }
          ]
        },
        applyDoneModal: {
          id: 'applyDoneModal',
          type: 'alert',
          title: '알림',
          size: 'modal-sm',
          fields: [
            {
              type: 'message',
              message: ['보험서비스 신청이 완료되었습니다.', '유지관리 페이지로 이동합니다.'],
              class: 'text-center'
            }
          ]
        }
      }
    },
    methods: {
      ...mapActions([
        'showToastMessage'
      ]),
      apply: function () {
        const vm = this
        const data = $.extend(true, {}, vm.data)

        // 로더 활성화
        vm.loaderActive = true

        // 업로드 된 파일정보를 String 형태로 변환한다.
        data['license_file'] = JSON.stringify(data['license_file'])
        data['permission_file'] = JSON.stringify(data['permission_file'])

        // 보험신청 API
        api.applyInsurance(data, response => {
          if (response.error) {
            // 로더 비활성화
            vm.loaderActive = false
            vm.showToastMessage('보험서비스 신청실패')
          } else {
            // 로더 비활성화
            vm.loaderActive = false

            // 신청이 완료되었을 경우, 신청완료 알림을 띄운다.
            vm.$refs.applyDoneModal.show()

            // 알림창이 닫히면 O&M 인덱스 페이지로 이동한다.
            $('#applyDoneModal').on('hidden.bs.modal', function () {
              vm.$router.push({name: 'insurance', params: {id: 'applyList'}})
            })
          }
        })
      },
      onSubmit: function () {
        const vm = this
        const firstArr = ['owner_name', 'onm_name', 'mobile_no', 'email']
        const secondArr = ['address', 'plant_name', 'install_position', 'install_capacity', 'install_type', 'driving_method', 'deduction_date', 'license_file', 'permission_file']
        const validateList = !vm.isNext ? firstArr : secondArr

        // validation 오류 목록을 초기화 한다.
        vm.errors.clear()

        // 현재 화면에 Field Validation
        for (let i in validateList) {
          vm.$validator.validate(validateList[i])
        }

        // validation이 끝난 후
        vm.$nextTick(() => {
          // 발생된 에러가 없을 경우, 보험신청 API 실행
          if (!vm.errors.any()) {
            if (vm.isNext) {
              // 보험신청 함수
              vm.apply()
            } else {
              // 다음 입력단계 활성화
              vm.isNext = true
            }
          } else {
            // Validation 실패 알림을 띄운다.
            vm.notifyModal.fields[0].message = ['입력정보를 확인해주세요.']
            vm.$refs.notifyModal.show()

            vm.$nextTick(() => {
              // 에러가 발생한 필드로 스크롤을 이동한다.
              vm.setScrollPosition('is-invalid-text')
            })
          }
        })
      },
      setScrollPosition: function () {
        // 제일 상단에 에러메세지로 스크롤을 이동한다.
        const error = $('p[class="is-invalid-text"]')

        if (error.length > 0) {
          // GNB와 입력필드에 높이를 계산하여 빼준다.
          const body = $('body')
          const position = (body.scrollTop() + error.offset().top) - 132

          $('html,body').stop().animate({scrollTop: (position)}, 500)
        }
      }
    },
    created: function () {
      const vm = this
      const token = localStorage.getItem('_t')

      if (token) {
        // 토큰 검증
        vm.$store.dispatch('inspectToken', token)
      } else {
        alert('로그인이 필요한 서비스 입니다. 로그인 화면으로 이동합니다.')
        vm.$router.push({name: 'login'})
      }
    },
    destroyed: function () {
      // 켄도 라이브러리에 의해 생성된 찌꺼기 엘리먼트 초기화.
      kendo.destroy(document.body)
    }
  }
</script>

<style lang="scss" scoped>
  #insuranceApply {

    .container {
      padding: 111px 0;
    }

    .title {
      margin: 0 0 40px 0;
      font-size: 32px;
      font-weight: bold;
      font-style: normal;
      font-stretch: normal;
      line-height: 1.25;
      letter-spacing: -1.6px;
      text-align: center;
      color: #2e3134;
    }

    .apply-step {
      margin-bottom: 32px;

      .col-xs-6 {
        padding: 24px;
        background-color: #eff1f8;
        font-size: 12px;
        font-weight: bold;
        font-style: normal;
        font-stretch: normal;
        line-height: 1.33;
        letter-spacing: -0.3px;
        border: solid 1px #eff1f8;
        color: #ced4da;

        .text-left {
          width: 50px;
          display: inline-block;
          float: left;
        }

        .text-right {
          width: calc(100% - 50px);
          display: inline-block;
          float: left;
        }
      }

      .apply-step-active {
        background-color: $hzc-white;
        border-color: #2b61ff;
        color: #2b61ff;
      }
    }

    .apply-form {
      margin-bottom: 64px;

      .form-category {
        padding: 16px 0;
        margin-bottom: 24px;
        border-bottom: 1px solid #ced4da;

        h4 {
          margin: 0;
          font-size: 20px;
          font-weight: bold;
          font-style: normal;
          font-stretch: normal;
          line-height: 1.2;
          letter-spacing: -0.9px;
          color: #2e3134;
        }
      }

      .form-group {
        margin-bottom: 16px;

        .col-md-4, .col-md-8 {
          padding: 0;
        }

        label {
          font-size: 16px;
          font-weight: bold;
          font-style: normal;
          font-stretch: normal;
          line-height: 48px;
          letter-spacing: -1.3px;
          color: #2e3134;

          @media (max-width: 991px) {
            line-height: 24px;
          }
        }

        input {
          width: 100%;
        }

        .hz-unit {
          position: absolute;
          top: 16px;
          right: 24px;
          color: #adb5bd;
          font-size: 12px;
          font-weight: bold;
        }

        .explain-text {
          margin: 4px 0;
        }
      }
    }

    .onm-btn-wrap  {
      padding-top: 64px;

      button {
        width: 167px;

        &:first-child {
          margin-right: 16px;
        }
      }
    }

    @media (max-width: 767px) {
      .container {
        padding: 69px 8px;
      }

      .title {
        font-size: 26px;
      }

      .apply-step .col-xs-6 {
        padding: 24px 8px;
      }

      .onm-btn-wrap {
        padding: 32px 0 0;

        button {
          width: 100%;

          &:first-child {
            margin: 0 0 8px 0;
          }
        }
      }
    }
  }
</style>



// WEBPACK FOOTER //
// src/pages/onm/InsuranceApply.vue